<template>
  <v-container class="pt-5 pb-1">
    <v-row>
      <v-col cols="12">
        <v-text-field
          v-model="form.role"
          type="text"
          hide-details
          label="Nome"
          outlined
          dense
          @input="
            (v) => {
              form.role = v.toUpperCase()
            }
          "
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-btn dark color="primary" text @click="close()"> Sair </v-btn>
      <v-btn dark color="blue darken-1" @click="setSubmit()"> Salvar </v-btn>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'FormRole',
  props: {
    closeDialog: {
      type: Function,
      default: () => {},
    },
    editData: {
      type: Object,
      default: () => {},
    },
  },
  data: function () {
    return {
      form: {
        role: null,
      },
    }
  },
  computed: {},
  watch: {
    editData: function () {
      if (this.editData.role != '') {
        this.form = { ...this.editData }
      } else {
        this.form = {}
      }
    },
  },
  mounted: function () {
    if (this.editData.role != '') {
      this.form = { ...this.editData }
    } else {
      this.form = {}
    }
  },
  methods: {
    ...mapActions('ui', ['ActionSetLoading']),
    ...mapActions('utils', ['ActionStoreRoles', 'ActionUpdateRoles']),
    async save() {
      if (this.form.role !== '') {
        this.ActionSetLoading(true)
        try {
          await this.ActionStoreRoles({ ...this.form })
          this.$swal({
            icon: 'success',
            title: 'Cadastrado',
            text: 'Cargo cadastrado com sucesso',
          })
          this.close()
        } catch (error) {
          console.error(error)
          this.$swal({
            icon: 'error',
            title: 'Erro',
            text: 'Não foi possivel cadastrar o cargo.',
          })
        } finally {
          this.ActionSetLoading(false)
        }
      }
    },
    async update() {
      if (!this.form.role) {
        return
      } else {
        this.ActionSetLoading(true)
        try {
          await this.ActionUpdateRoles({ ...this.form })
          this.$swal({
            icon: 'success',
            title: 'Atualizado',
            text: 'Cargo atualizado com sucesso.',
          })
          this.closeDialog()
        } catch (error) {
          console.error(error)
          this.$swal({
            icon: 'error',
            title: 'Erro',
            text: 'Não foi possível atualizar o cargo.',
          })
        } finally {
          this.ActionSetLoading(false)
        }
      }
    },
    close() {
      this.closeDialog()
      this.form = {}
    },
    setSubmit() {
      if (!this.editData.role) {
        this.save()
      } else {
        this.update()
      }
    },
  },
}
</script>
